import type { SvgIconComponent } from "@mui/icons-material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import LinkOffOutlinedIcon from "@mui/icons-material/LinkOffOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import { RequestOriginGroup, RequestOriginKind } from "../../../utils/models";
import type { AccentIconTileTone } from "../../UIToolkit/molecules/AccentIconTile";

/** The glyph is the kind: its shape alone says what opened the slot. */
export const ORIGIN_KIND_ICON: Readonly<Record<RequestOriginKind, SvgIconComponent>> = {
	[RequestOriginKind.CallOff]: PersonRemoveOutlinedIcon,
	[RequestOriginKind.ReplaceRequest]: SwapHorizOutlinedIcon,
	[RequestOriginKind.SwapRequest]: SwapHorizOutlinedIcon,
	[RequestOriginKind.TimeOff]: EventBusyOutlinedIcon,
	[RequestOriginKind.TimeOffHris]: EventBusyOutlinedIcon,
	[RequestOriginKind.Deactivation]: PersonOffOutlinedIcon,
	[RequestOriginKind.PostedByPerson]: PersonOutlineOutlinedIcon,
	[RequestOriginKind.FromRecommendation]: LightbulbOutlinedIcon,
	[RequestOriginKind.PostedByAnnie]: AutoAwesomeOutlinedIcon,
	[RequestOriginKind.AutoPost]: BoltOutlinedIcon,
	[RequestOriginKind.Agency]: HubOutlinedIcon,
	[RequestOriginKind.AgencyCanceled]: LinkOffOutlinedIcon,
	[RequestOriginKind.CountRaised]: GroupAddOutlinedIcon,
};

/** The tile's tone is the group — shown only once a card is open, so the list stays colourless. */
export const ORIGIN_GROUP_TONE: Readonly<Record<RequestOriginGroup, AccentIconTileTone>> = {
	[RequestOriginGroup.Automation]: "primary",
	[RequestOriginGroup.People]: "neutral",
	[RequestOriginGroup.External]: "info",
};

/** Where an origin was looked at, for `request_origin_viewed`. */
export enum RequestOriginViewLevel {
	List = "list",
	Gaps = "gaps",
}

/** The Origin filter's state, as the Requests screen owns it, with the per-group counts for its current scope. */
export type OriginFilterControl = {
	selected: readonly RequestOriginGroup[];
	onChange: (next: RequestOriginGroup[]) => void;
	counts: Readonly<Record<RequestOriginGroup, number>>;
};

/** Each group's glyph in the Origin filter: the kind most of it is. */
export const ORIGIN_GROUP_ICON: Readonly<Record<RequestOriginGroup, SvgIconComponent>> = {
	[RequestOriginGroup.Automation]: BoltOutlinedIcon,
	[RequestOriginGroup.People]: PersonOutlineOutlinedIcon,
	[RequestOriginGroup.External]: HubOutlinedIcon,
};

/** Which Requests layout a filter change came from, for `request_origin_filter_changed`. */
export enum RequestOriginFilterLayout {
	Classic = "classic",
	Gaps = "gaps",
}
